import React from 'react';
import './CommentButton.css';

export class CommentButton extends React.Component {

  static getButtonId (id) {
    return `comment-button-${id}`;
  }

  static getIconId (id) {
    return `comment-icon-${id}`;
  }

  render () {
    const { id, className } = this.props;
    return (
      <div className={ `presentation-animations ${!!className ? className : ''}` }>
        <button id={ CommentButton.getButtonId(id) } className="comment">
          <svg
            id={ CommentButton.getIconId(id) }
            width="21px"
            height="19px"
            viewBox="0 0 21 19"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg">
            <g id="Live-View" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g id="Artboard-2" transform="translate(-223.000000, -60.000000)">
                <g id="Group" transform="translate(208.000000, 46.000000)">
                  <path d="M15,22.7889234 C15,17.694151 19.6714147,13.9915491 25.3800001,14.0000145 C31.0885855,14.0084798 35.7600002,17.694151 35.7600002,22.7889234 C35.7600002,27.8836958 30.6937077,31.5778323 25.3800001,31.5778323 C24.5077067,31.5778323 23.5419135,31.4485596 22.7431285,31.3870095 C21.9443436,31.3254594 20.3207407,32.8756166 18.3027273,32.6835003 C19.4005485,31.9145062 19.8281587,31.0213531 19.9553264,30.2449439 C17.0718505,28.7322528 15,26.0469817 15,22.7889234 Z" id="Oval-8" fill="#3D9AE2"></path>
                  <rect id="Rectangle-31" x="0" y="0" width="50" height="50"></rect>
                </g>
              </g>
            </g>
          </svg>
        </button>
      </div>
    );
  }
}
